import React, { Component } from 'react'
import {connect} from 'react-redux'
import { Redirect } from 'react-router-dom'
import { CreateNew } from '../../actions'
import { Field, reduxForm } from 'redux-form'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

class Createproject extends Component {
    renderinput = ({ input, meta, title }) => {
         const classname = `seven wide field ${meta.touched && meta.error ? "error" : ""}`
        console.log(meta)
        return (
            
            <div className={classname}>
                 <label>{title}</label>
                <input {...input} />
                {this.rendererror(meta)}
        </div>
    )
    }
    rendertextarea = ({input, meta, title}) => {
        const classname = `seven wide field ${meta.touched && meta.error ? 'error' : ''}`;
        return (
            <div className={classname}>
                <label>{title}</label>
                <textarea {...input} />
                {this.rendererror(meta)}
            </div>
        )
    }
    rendererror = ({touched, error}) => {
        if (touched && error) {
            return (
                <div className="ui error message">
                    <div className="header">{ error }</div>
                </div>
            )
        }
    }

   
    onInputChange = (e) => {
        this.setState({
            [e.target.id]:e.target.value
        })
    }
   
    onFormSubmit = (values) => {
        const { auth } = this.props
       
        this.props.CreateNew({...values, userId:auth.uid})
    }
    render() {
       
        const { auth } = this.props
        if(!auth.uid) return <Redirect to="/login"/>
        return (
            <form className="ui form error" style={{ marginTop: '25px' }} onSubmit={this.props.handleSubmit(this.onFormSubmit)}>
                <h2 style={{fontSize:"32px", fontFamily:'Tahoma'}}>Create Project</h2>
                
                   
                    <Field type="text" name="title" placeholder="Title" component={this.renderinput} title='enter a title' />
               
                
                
                
                   
                    <Field  name="content" placeholder="content" component={this.rendertextarea} title='enter a content' style={{paddingRight:'0'}} />
               
               
               
                   

                <button type="submit" className="ui button primary">
                    <FontAwesomeIcon icon="plus-circle" style={{marginRight:"5px"}}/>
                    Create New Project
                    </button>
                
            </form>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth:state.firebase.auth
    }
}
const validate = (values) => {
    const error = {}
    if (!values.title) {
        error.title='you must enter a title'
    }
    if (!values.content) {
        error.content='you must enter a content'
    }
    return error
}
const combinedForm = reduxForm({
    form: 'create',
    validate
})(Createproject)
export default connect(mapStateToProps, {CreateNew})(combinedForm)

